// extracted by mini-css-extract-plugin
export var reviews = "style-module--reviews--6980f";
export var reviews__title = "style-module--reviews__title--2cd0a";